import { inject, Injectable, OnDestroy } from '@angular/core';
import { Location, LocationStrategy } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router, UrlTree } from '@angular/router';
import {
  routeError,
  routeLogoff,
  routeMessages,
  routeOrders,
  routeForms,
  routeOfflineOrders
} from '../liveformsweb.routes';
import { Subscription } from 'rxjs';
import { AppUrls } from './app-urls';
import { ProjectsService } from '../projects/projects.service';

@Injectable({
  providedIn: 'root'
})
export class LfwRouterService implements OnDestroy {
  subscription: Subscription = new Subscription();

  private readonly projectService = inject(ProjectsService);
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly locationStrategy = inject(LocationStrategy);

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getUrl(): string {
    return this.router.url;
  }

  navigateByUrl(url: string): void {
    this.router.navigateByUrl(url).catch((reason) => console.error(`navigateByUrl ${url} failed`, reason));
  }

  navigateToLoggedOff(): void {
    this.route(routeLogoff);
  }

  get canNavigateBack(): boolean {
    return this.router.navigated && window.history.length > 1;
  }

  navigateBack(): void {
    if (history.length > 1) {
      this.location.back();
    } else {
      this.navigateToOrdersRoot();
    }
  }

  navigate(segments: string[], options?: NavigationExtras): void {
    this.router.navigate(segments, options);
  }

  /*
   navigateToProjectsRoot() {
     if (this.projectService.moreThanOneProjectAvailable$ || !this.projectService.projectsAvailable$) {
       this.route(routeProjects);
       return;
     }
     this.navigateToOrdersRoot();
  }
*/

  navigateToOrdersRoot(): void {
    this.route(`${routeOrders}/${this.projectService.currentProjectId}`);
  }

  navigateToForm(formId: string): void {
    this.router.navigate([routeForms, this.projectService.currentProjectId, formId]);
  }

  navigateToOfflineOrdersOverview(): void {
    this.route(`${routeOfflineOrders}`);
  }

  navigateToMessages(): void {
    this.route(routeMessages);
  }

  navigateToPasswordChange(): void {
    let destUrl = AppUrls.getAuthUrl(AppUrls.actionAuthPswChange);
    destUrl = `${destUrl}?ReturnUrl=${encodeURI(window.location.href)}`;
    window.location.href = destUrl;
  }

  setQueryParams(key: string, value: string, replaceUrl = true): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { [key]: value },
      skipLocationChange: false,
      queryParamsHandling: 'merge',
      replaceUrl
    });
  }

  getQueryParam(key: string): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get(key);
  }

  errorStop(errorId: string): void {
    this.route(routeError, { error: errorId });
  }

  createExternalUrl(tree: UrlTree): string {
    return this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(tree));
  }

  private route(path: string, params: any = null, clearRoutes = false): void {
    if (params != null) {
      this.router
        .navigate([path, params], { replaceUrl: clearRoutes })
        .catch((reason) => console.error(`navigation to ${path} failed`, params, reason));
    } else {
      this.router
        .navigate([path], { replaceUrl: clearRoutes })
        .catch((reason) => console.error(`navigation problem to: ${path}`, reason));
    }

    if (clearRoutes) {
      // history.length;  ??
    }
  }
}
